(function () {
	const preventProductNavigation = (event) => {
		event.preventDefault();
		event.stopPropagation();
	};

	const initSlider = () => {
		const sliders = document.querySelectorAll(".product-card-js");

		sliders.forEach((slider) => {
			if (slider.swiper) return;

			const nextEl = slider.querySelector(".swiper-button-next");
			const prevEl = slider.querySelector(".swiper-button-prev");
			const paginationEl = slider.querySelector(".swiper-pagination");

			slider
				.querySelectorAll(
					".product-button-group, .product-pagination, .swiper-button-next, .swiper-button-prev"
				)
				.forEach((control) => {
					control.addEventListener("click", preventProductNavigation);
				});

			new Swiper(slider, {
				pagination: paginationEl
					? {
							el: paginationEl,
							clickable: true,
					  }
					: undefined,
				navigation:
					nextEl && prevEl
						? {
								nextEl,
								prevEl,
						  }
						: undefined,
				allowTouchMove: true,
				breakpoints: {
					990: {
						allowTouchMove: false,
					},
				},
			});
		});
	};

	window.initProductCardSliders = initSlider;

	initSlider();

	document.addEventListener("shopify:section:load", function () {
		initSlider();
	});
})();
